<template>
	<BarAbstract>
		<div id="BottomBar">
			<span v-for="(action, key) in props.actions">
    			<span v-if="action.label" class="keybinding" v-bind:class="{ right: action.alt }">
    				<span class="Hotkey">{{key}} </span>
    				<span class="label">{{action.label}}</span>
    			</span>
			</span>
		</div>
	</BarAbstract>
</template>


<script>
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import BarAbstract from '../BarAbstract';
  import KeyboardManager from '../../util/keyboardManager.js';

  @Component({
      components: {
          BarAbstract,
      }
  })
  export default class BottomBar extends BarAbstract {
      props = {actions: {}};

      onBindingChange = (bindings) => {
          this.props.actions = bindings;
      }
      
      mounted() {
          KeyboardManager.addListener(this.onBindingChange);
          this.props.actions = KeyboardManager.getBindings();
      }
      
      destroyed() {
          KeyboardManager.removeListener(this.onBindingChange);
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	p {
		margin-top: 0;
		text-align: left;
	}
	.keybinding {
		margin-right: 2vmin;
	}
	.right {
    	float: right;
	}
</style>
